import React from 'react';
import { Section } from '../ui/Section';
import { Check } from 'lucide-react';
export function QueIncluye() {
  const items = [{
    title: '4 menús listos',
    desc: '1 persona / pareja / familia / bajo presupuesto'
  }, {
    title: 'Listas de compras por pasillos',
    desc: 'Imprimible + versión "captura de pantalla"'
  }, {
    title: 'Swaps inteligentes',
    desc: 'Si no hay X, hacés Y (sin dramatizar)'
  }, {
    title: 'Plan de emergencia',
    desc: '10 opciones salvavidas para cuando no cocinaste'
  }, {
    title: 'Plantillas reutilizables',
    desc: 'Para repetir cada semana sin volver a pensar desde cero'
  }];
  return <Section background="white" data-id="element-252">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-stone-900" data-id="element-253">
        Qué incluye (y por qué es diferente)
      </h2>

      <div className="grid gap-6" data-id="element-254">
        {items.map((item, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-lg hover:bg-stone-50 transition-colors" data-id="element-255">
            <div className="bg-green-100 p-1 rounded-full mt-1" data-id="element-256">
              <Check className="w-5 h-5 text-green-700" data-id="element-257" />
            </div>
            <div data-id="element-258">
              <h3 className="text-lg font-bold text-stone-900" data-id="element-259">{item.title}</h3>
              <p className="text-stone-600" data-id="element-260">{item.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="mt-10 text-center" data-id="element-261">
        <p className="text-lg font-medium text-stone-900 border-t border-b border-stone-200 py-4 inline-block px-8" data-id="element-262">
          Todo en un PDF directo, sin relleno.
        </p>
      </div>
    </Section>;
}